import { FC } from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import { useMatches } from 'react-router-dom';
import style from './style';
import { NavigationBarItemType } from '@/components/ui/NavigationBar/types';

interface SubItemsListProps {
  subItems: NavigationBarItemType[];
  onSubItemClick: (subItemPath: string, mainItemIcon: string) => void;
  mainItemIcon: string;
  /**
   * Aktiver Unterpunkt, wenn er NICHT aus der Route ableitbar ist — z.B. in der
   * Beratungsstrecke, wo die "Unterpunkte" Scroll-Sektionen einer einzigen
   * Seite sind und useMatches folglich nie anschlaegt. Ohne die Prop bleibt es
   * beim bisherigen Routen-Abgleich.
   */
  activePath?: string;
}

const SubItemsList: FC<SubItemsListProps> = ({
  subItems,
  onSubItemClick,
  mainItemIcon,
  activePath,
}) => {
  const matches = useMatches();

  const isActive = (path: string) => {
    if (activePath !== undefined) {
      return path === activePath;
    }
    return matches.some(
      (match) =>
        match.pathname.endsWith(`/${path}`) ||
        match.pathname.includes(`/${path}/`),
    );
  };

  if (subItems.length === 0) {
    return null;
  }

  return (
    <Stack sx={style.subItemsContainer}>
      <Divider sx={style.divider} />
      {subItems.map((subItem, subIndex) => (
        <Typography
          key={subIndex}
          variant="meta"
          sx={[
            style.subItemLabel,
            isActive(subItem.path) && style.activeSubItemLabel,
          ]}
          onClick={() => onSubItemClick(subItem.path, mainItemIcon)}
        >
          {subItem.label}
        </Typography>
      ))}
    </Stack>
  );
};

export default SubItemsList;
